import type { SurveyTemplateErrors } from './types'

type ValidationMessages = Record<string, string[] | string>

const firstMessage = (value: string[] | string | undefined) =>
  Array.isArray(value) ? value[0] : value

/**
 * Reads the 422 body of the survey bank endpoints (`{ message: { name: [...],
 * questions: [...] } }`) so each message lands on the step that shows it.
 * Returns null when the error is not a validation error.
 */
export const readValidationErrors = (
  error: unknown
): SurveyTemplateErrors | null => {
  const response = (
    error as {
      response?: { status?: number; data?: { message?: unknown } }
    }
  )?.response
  if (response?.status !== 422) return null

  const message = response.data?.message
  if (!message || typeof message !== 'object') return {}

  const messages = message as ValidationMessages
  const errors: SurveyTemplateErrors = {}
  const name = firstMessage(messages.name)
  const questions = firstMessage(messages.questions)
  if (name) errors.name = name
  if (questions) errors.questions = questions
  return errors
}
